import { useTranslation } from 'react-i18next';
import { getKalenderTableColumns } from './KalenderTableColumns';

export function useKalenderTableColumns() {
  const { t } = useTranslation();
  return getKalenderTableColumns(t);
}
